type Body1 = {
    fontFamily: any;
    fontWeight: any;
    fontStyle: any;
    fontSize: any;
    letterSpacing: any;
    lineHeight: any;
};

export const body1: Body1 = {
    'fontFamily': 'var(--plasma-typo-body1-font-family, \'SB Sans Text\',sans-serif)',
    'fontWeight': 'var(--plasma-typo-body1-font-weight, 500)',
    'fontStyle': 'var(--plasma-typo-body1-font-style, normal)',
    'fontSize': 'var(--plasma-typo-body1-font-size, 1rem)',
    'letterSpacing': 'var(--plasma-typo-body1-letter-spacing, -0.0190em)',
    'lineHeight': 'var(--plasma-typo-body1-line-height, 1.25rem)'
};